export const NAV_SECTIONS = [
  { id: "about", label: "About" },
  { id: "upcoming", label: "Upcoming events" },
  { id: "publications", label: "Publications" },
  { id: "interviews", label: "Interviews" },
  { id: "past", label: "Past events" },
] as const;

export const SECTION_ROUTES = NAV_SECTIONS.map((session) => "/" + session.id);

export const SCROLL_GAP = 8;

/**
 * Clears the scroll restoration state for a given path.
 * The scroll restorer library stores scroll positions with keys derived from paths.
 * Call this when navigating via hero buttons to start at the top of the page.
 *
 * @param href - The path to clear scroll state for (e.g., "/sessions", "/events")
 */
export function clearScrollState(href: string): void {
  try {
    // Extract the path portion (without query params or hash)
    const path = href.split("?")[0]?.split("#")[0] ?? href;
    // Remove leading slash and convert to scroll key format
    const scrollKey = `${path.replace(/^\//, "")}-scroll`;
    sessionStorage.removeItem(scrollKey);
  } catch {
    // sessionStorage may not be available (SSR, privacy mode, etc.)
  }
}
